export const DAST = 
{
    Metadata:{Name:'DAST-10',maxColumn:2,numRows:10},
    Sections:
    [
        {
            Headers:[
                "Illegal Drugs, including marijuana, and/or use of a prescription medication for " +
                "non-medical reasons are considered to be drugs. <span class='importantText'>In the past 12 months...</span>",
                "Yes",
                "No",
            ],
            Questions:[
                {
                    Prompt:"1. Have you used drugs other than those required for medical reasons?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"2. Do you use more than one drug at a time?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"3. Are you always able to stop using drugs when you want to?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"4. Have you ever had blackouts or flashbacks as a result of drug use?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"5. Do you ever complain about your involvement with drugs?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"6. Do people in your life ever complain about your involvement with drugs?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"7. Have you ever neglected your family because of you ruse of drugs?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"8. Have you ever engaged in illegal activities in order to obtain drugs?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"9. Have you ever experienced withdrawal symptoms (felt sick) when you stopped taking drugs?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"10. Have you ever had medical problems as a result of your drug use? (e.g. memory loss, hepatitis, convulsions, bleeding)",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
            ]
        }
    ]
}